var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "row align-items-center" }, [
    _vm.hasOptions
      ? _c(
          "div",
          { staticClass: "col-12 col-xxl-6 mb-3 mb-xxl-0" },
          [
            _c(
              "ci-fe-wrapper",
              {
                attrs: { label: _vm.label },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              },
              [
                _c("v-select", {
                  staticClass: "ci-form--input",
                  attrs: {
                    label: "label",
                    reduce: (option) => option.value,
                    options: _vm.translatedOptions,
                    searchable: !_vm.$root.handheld,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$emit("input", $event ? $event.value : "")
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "open-indicator",
                        fn: function ({ attributes }) {
                          return [
                            _c(
                              "span",
                              _vm._b(
                                { staticClass: "mdi mdi-chevron-down text-lg" },
                                "span",
                                attributes,
                                false
                              )
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1098627443
                  ),
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { class: _vm.hasOptions ? "col-12 col-xxl-6" : "col-12" },
      [
        _vm.concatenatedAttribute
          ? _c("ais-range-input", {
              attrs: {
                attribute: _vm.concatenatedAttribute,
                precision: 2,
                min: _vm.min,
                max: _vm.max,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({
                      currentRefinement,
                      range,
                      canRefine,
                      refine,
                    }) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("input", {
                              staticClass: "form-control w-25",
                              attrs: {
                                type: "number",
                                min: range.min,
                                max: range.max,
                                step: "0.01",
                                placeholder: range.min,
                                disabled: !canRefine,
                              },
                              domProps: {
                                value: _vm.formatMinValue(
                                  currentRefinement.min,
                                  range.min
                                ),
                              },
                              on: {
                                input: function ($event) {
                                  refine({
                                    min: $event.currentTarget.value,
                                    max: _vm.formatMaxValue(
                                      currentRefinement.max,
                                      range.max
                                    ),
                                  })
                                },
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "w-50 px-4" },
                              [
                                _c("ci-vue-slider", {
                                  attrs: {
                                    min: range.min,
                                    max: range.max,
                                    lazy: true,
                                    interval: 0.01,
                                    value: _vm.toValue(
                                      currentRefinement,
                                      range
                                    ),
                                    silent: true,
                                    disabled: !canRefine,
                                  },
                                  on: {
                                    change: function ($event) {
                                      refine({
                                        min: _vm.formatMinValue(
                                          $event[0],
                                          range.min
                                        ),
                                        max: _vm.formatMaxValue(
                                          $event[1],
                                          range.max
                                        ),
                                      })
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("input", {
                              staticClass: "form-control w-25",
                              attrs: {
                                type: "number",
                                min: range.min,
                                max: range.max,
                                step: "0.01",
                                placeholder: range.max,
                                disabled: !canRefine,
                              },
                              domProps: {
                                value: _vm.formatMaxValue(
                                  currentRefinement.max,
                                  range.max
                                ),
                              },
                              on: {
                                input: function ($event) {
                                  refine({
                                    min: _vm.formatMinValue(
                                      currentRefinement.min,
                                      range.min
                                    ),
                                    max: $event.currentTarget.value,
                                  })
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1175933095
              ),
            })
          : _c("div", [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("input", {
                  staticClass: "form-control w-25",
                  attrs: { type: "number", placeholder: "0", disabled: true },
                }),
                _c(
                  "div",
                  { staticClass: "w-50 px-4" },
                  [
                    _c("ci-vue-slider", {
                      attrs: {
                        min: 0,
                        max: 0,
                        lazy: true,
                        disabled: true,
                        interval: 0.01,
                        value: [0, 0],
                        silent: true,
                      },
                    }),
                  ],
                  1
                ),
                _c("input", {
                  staticClass: "form-control w-25",
                  attrs: { type: "number", placeholder: "0", disabled: true },
                }),
              ]),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }